import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Pin } from 'src/app/models/Pin';
import { PinService } from 'src/app/services/pin.service';
import { ShareDataService } from 'src/app/services/shareData.service';
import { CONSTANTES } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-pin-generator',
  templateUrl: './pin-generator.component.html',
  styleUrls: ['./pin-generator.component.scss']
})
export class PinGeneratorComponent implements OnInit {

  imagesUrl = CONSTANTES.pasadoresUrl;
  tableTitle: string[] = ["Tipo de Condecoración", "Condecoraciones Seleccionadas", "Número Pasadores"];
  types: string[] = ["Condecoraciones civiles españolas de las Ordenes y recompensas civiles que se correspondan a otras categorias o grados inferiores a Gran Cruz",
    'Condecoraciones Militares', 'Condecoraciones militares y civiles extranjeras', 'Grandes Cruces de otras Ordenes Españolas', 'Medallas conmemorativas',
    'Medallas de campañas', 'Medallas de organizaciones internacionales'];
  parents: string[] = ["Civiles españolas", 'Militares', 'Militares y civiles extranjeras', 'Grandes Cruces', 'Conmemorativas', 'De campaña', 'Organizaciones Internacionales']
  typePinesTitle: Map<string, number> = new Map();
  allPinesTitle: Map<string, number> = new Map();
  pines: Pin[] = [];
  columns: number = 4;
  public activePillIndex: number = 0;
  selectedPines: Pin[] = [];
  isExpanded = false;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private shareDataService: ShareDataService,
    private pinService: PinService
  ) { }

  ngOnInit() {
    try {
      jQuery.getScript(CONSTANTES.menu);
    } catch (Error) {
      this.router.navigate(['login']);
    }
    this.columns = (window.innerWidth <= 900) ? 2 : 2;
    this.columns = (window.innerWidth <= 1396) ? 2 : 4;

    this.getAllPines();
  }


  getAllPines() {
    this.spinner.show();
    this.pinService.getAllPins().subscribe(
      data => {
        this.pines = data.pins;
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        this.toastr.error("ERROR AL OBTENER LOS PASADORES");
      }
    )
  }

  addPin(pin: any) {
    let date = <HTMLInputElement>document.getElementById('inputDate-' + pin.id)
    if (pin.type === this.types[this.types.length - 1] && (date.value == null || date.value.trim() === '')) {
      this.toastr.warning("INTRODUZCA UNA FECHA ANTES DE INTENTAR INSERTAR EL PASADOR")
    }
    else {
      if (pin.type === this.types[this.types.length - 1] && (date.value != null && date.value.trim() !== '')) {
        pin.date = new Date(date.value);
      }
      if (!pin.quantityCheck) {
        let quantity = <HTMLInputElement>document.getElementById('input-' + pin.id)
        for (let i = 0; i < quantity.valueAsNumber; i++) {
          this.selectedPines.push(pin)
        }
        this.toastr.success('PASADORES INCLUIDOS')
      }
      else {
        if (this.selectedPines.find((pins) => pins.name === pin.name) === undefined) {
          this.selectedPines.push(pin);
          this.toastr.success('PASADOR INCLUIDO')
        } else {
          this.toastr.warning('SOLO PUEDES INCLUIR UN PASADOR DE ESTE TIPO')
        }
      }
      this.orderArray()
      this.updateTable()
    }
  }

  orderArray() {
    this.selectedPines.sort((a, b) => {
      if (a.date != null && b.date != null) {
        if (a.date.getTime() - b.date.getTime() == 0) {
          return a.position - b.position;
        }
        else {
          return a.date.getTime() - b.date.getTime();
        }
      }
      else {
        return a.position - b.position;
      }
    })
  }

  updateTable() {
    this.types.forEach(titulo => {
      let pinesTitulo = this.selectedPines.filter(pin => pin.type === titulo)
      this.allPinesTitle.set(titulo, pinesTitulo.length);
      const item = [...new Set(pinesTitulo)];
      this.typePinesTitle.set(titulo, item.length)
    })
  }

  restablecer() {
    this.selectedPines = [];
  }

  confirmar() {
    this.shareDataService.changePines(this.selectedPines);
    this.router.navigate(['pin-result']);
  }

  public selectPill(index: number) {
    this.activePillIndex = index;
  }

  onResize(event) {
    if (event.target.innerWidth <= 1396) {
      this.columns = 2;
    }
    else {
      this.columns = 4;
    }
  }
}
